import styled from "styled-components";

export const ContactUsMAinSec = styled.section`
  .container__flex {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    .div__column {
      width: 45%;
    }
  }

  h2 {
    margin-bottom: 2.5rem;
  }

  .link__color {
    color: #000;
  }

  .info__line {
    display: flex;
    align-items: center;
    flex-direction: row;
    
    gap: 1.25rem;
    border-top: 1px solid #000;
    padding: 1.563rem 0 1.563rem 0;

    &:last-child {
      border-bottom: 1px solid #000;
    }
  }

  @media(max-width:768px){
    .container__flex {
      flex-direction: column;
      .div__column {
      width: 100%;
    }
    }
  }
  
  @media(max-width:360px){
    .info__line{
      flex-direction: column;
      text-align: center;
    }
  }
`;

export const MapWrapper = styled.div`
  position: relative;
  z-index: 0;
  width: 100%;
  height: 31.25rem;
  border: 1px solid #000;
  border-radius: 0.5rem;
  overflow: hidden;
`;
